module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ct2"
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }, [_vm._v("Praise for "), _c('i', [_vm._v("Blood Trade")])])]), _c('a', {
    attrs: {
      "id": "page_viii"
    }
  }, [_c('p', {
    staticClass: "tx1-1"
  }, [_vm._v("“This book has so many twists, turns, mis-directions and layers of plot that I even forgot to eat where I was so involved. The characters are larger than life and when you think you know them there is another surprise just around the corner.”")]), _vm._v(" "), _c('p', {
    staticClass: "txr"
  }, [_c('b', [_vm._v("— Best Selling Crime Thrillers")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1-1"
  }, [_vm._v("5 stars. “Blood Trade is an awesome read that keeps you on your toes. You never know what is going to happen next and each new piece of the puzzle that is revealed is something you’d never expect. This is not one of those “guess who did it” thrillers. You honestly can’t do that. You’ll have the ah-ha moments when your realize who did something, but you’d never guess it was that person before-hand.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("John A. Daly is masterful at writing a good thriller and I can’t wait to read more thriller novels from him.”")]), _vm._v(" "), _c('p', {
    staticClass: "txr"
  }, [_c('b', [_vm._v("— The Goth Girl Reads")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1-1"
  }, [_vm._v("“This is the first book I’ve read from John Daly, it is not the first in the series but I was not confused. This book could be read as a stand alone. The main character Sean Coleman is not your typical Hot guy that can’t do anything wrong. He has an alcoholic past, and the town where he lives doesn’t take him serious, and is just a joke to them. Thus making a Believable character with flaws, that is more real.”")]), _vm._v(" "), _c('p', {
    staticClass: "txr"
  }, [_c('b', [_vm._v("— Vanessa Visagie, Vanessa Reviews")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1-1"
  }, [_vm._v("“The second in a series that will certainly continue, this book is a darned good read. The status of hero is shared by a super cop now living in a small community and his hapless (formerly) alcoholic brother-in-law. The main characters are well developed and the storyline good. This reader was torn between who to cheer for (the ‘goodies’ or the ‘baddies’) on several occasions and in many respects, the plot is quite unique.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("An enjoyable read with characters that wouldn’t fit in with either the ‘gung ho’ or the ‘splendidly rich and beautiful’ crowd that usually populate American action stories and all the better for it!")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("This is a stand alone book despite being the second in the series. My enjoyment wasn’t marred by not having read the first and I will certainly go back and read the predecessor.”")]), _vm._v(" "), _c('p', {
    staticClass: "txr"
  }, [_c('b', [_vm._v("— Mary Edgley, Goodreads")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a62361a8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/frontmatter04.vue
// module id = 72
// module chunks = 0